import { render } from "./NetworkDeFi.vue?vue&type=template&id=61681288"
import script from "./NetworkDeFi.vue?vue&type=script&lang=js"
export * from "./NetworkDeFi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__